import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

const ErrorFallback = ({ error, errorInfo, onReset }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-6">
            <AlertTriangle className="w-10 h-10 text-red-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-3">
            Oops! Algo salió mal
          </h1>
          <p className="text-gray-600">
            Ha ocurrido un error inesperado en la aplicación.
          </p>
        </div>

        <div className="bg-gray-50 rounded-xl p-6 mb-6">
          <h2 className="text-lg font-semibold text-gray-800 mb-3">
            Detalles del error:
          </h2>
          <div className="bg-gray-800 text-gray-100 p-4 rounded-lg overflow-auto max-h-60">
            <code className="text-sm">
              {error && error.toString()}
            </code>
            {errorInfo && (
              <pre className="mt-4 text-xs">
                {errorInfo.componentStack}
              </pre>
            )}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={onReset}
            className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold py-3 px-6 rounded-lg hover:opacity-90 transition-opacity"
          >
            <RefreshCw className="w-5 h-5" />
            Reintentar
          </button>
          
          <button
            onClick={() => window.location.href = '/'}
            className="flex-1 flex items-center justify-center gap-2 bg-gray-800 text-white font-semibold py-3 px-6 rounded-lg hover:opacity-90 transition-opacity"
          >
            <Home className="w-5 h-5" />
            Volver al Inicio
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500 text-center">
            Si el problema persiste, contacta al soporte técnico.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
